export const draftIdeaPlaceholders = [
  'Has the fight over executive power gone too far, or not far enough?',
  'Should governments slow frontier AI research before it outpaces public oversight?',
  'Has outrage-driven news coverage made audiences less informed?',
  'Should AI-generated art compete for the same major awards as human-made work?',
  'Is “authenticity” now a brand strategy more than a cultural value?',
  'Do global sanctions change governments, or mostly punish ordinary people?',
  'Should social-media recommendation algorithms be treated as public infrastructure?',
  'Has sports betting changed fandom beyond repair?',
  'Are universities protecting open debate, or policing it too aggressively?',
  'Is remote work expanding freedom or hollowing out our cities?',
  'Are parents overprotecting kids, or leaving them too exposed online?',
  'Should schools ban phones all day, even if it limits a student’s independence?',
  'Has music streaming made hit songs disposable, and musicians less sustainable?',
  'Is Hollywood’s reboot obsession killing original storytelling or funding the risks audiences say they want?',
  'Are memes our sharpest form of political commentary, or a machine for flattening every serious issue?',
] as const;

export const draftIdeaExampleLabels = [
  'Executive power',
  'AI oversight',
  'Outrage news',
  'AI art awards',
  'Authenticity',
  'Sanctions',
  'Social algorithms',
  'Sports betting',
  'Campus debate',
  'Remote work',
  'Parenting',
  'School phones',
  'Music streaming',
  'Reboot culture',
  'Political memes',
] as const;

export function createDraftIdeaPlaceholderCycle(
  placeholders: readonly string[] = draftIdeaPlaceholders,
  random: () => number = Math.random,
) {
  let remaining: string[] = [];
  let previous = '';

  return () => {
    if (remaining.length === 0) {
      remaining = shuffle([...placeholders], random);
      if (remaining.length > 1 && remaining[remaining.length - 1] === previous) {
        [remaining[remaining.length - 1], remaining[remaining.length - 2]] = [remaining[remaining.length - 2], remaining[remaining.length - 1]];
      }
    }

    const placeholder = remaining.pop();
    if (!placeholder) return '';
    previous = placeholder;
    return placeholder;
  };
}

export function createDraftIdeaExampleIndexCycle(
  count = draftIdeaPlaceholders.length,
  random: () => number = Math.random,
) {
  let remaining: number[] = [];
  let previousIndex: number | null = null;

  return () => {
    if (count <= 0) return null;

    if (remaining.length === 0) {
      remaining = shuffle(Array.from({ length: count }, (_, index) => index), random);
      if (remaining.length > 1 && remaining[remaining.length - 1] === previousIndex) {
        [remaining[remaining.length - 1], remaining[remaining.length - 2]] = [remaining[remaining.length - 2], remaining[remaining.length - 1]];
      }
    }

    const index = remaining.pop();
    if (index === undefined) return null;
    previousIndex = index;
    return index;
  };
}

function shuffle<T>(values: T[], random: () => number) {
  for (let index = values.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(random() * (index + 1));
    [values[index], values[swapIndex]] = [values[swapIndex], values[index]];
  }
  return values;
}
